import script from "./ElementProgressMilestones.vue?vue&type=script&setup=true&lang=js"
export * from "./ElementProgressMilestones.vue?vue&type=script&setup=true&lang=js"

import "./ElementProgressMilestones.vue?vue&type=style&index=0&id=82745596&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82745596"]])

export default __exports__